import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetMilkOptions = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.MILK_OPTIONS],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.getMilkOptionsApiV1MealsMilkOptionsGet(user.id);
      return data?.milkOptions ?? [];
    },
  });

  return {
    milkOptions: data,
    isLoading,
    isError,
    error,
  };
};
